(function () {
  if (window.__messydLazyVideo) return;
  window.__messydLazyVideo = true;

  function hydrate(video) {
    if (!video) return;
    var changed = false;
    video.querySelectorAll("source[data-src]").forEach(function (source) {
      if (!source.getAttribute("src")) {
        source.setAttribute("src", source.getAttribute("data-src"));
        changed = true;
      }
    });
    if (changed) video.load();
  }

  document.addEventListener(
    "click",
    function (event) {
      var host = event.target.closest && event.target.closest("internal-video");
      if (!host) return;
      hydrate(host.querySelector("video"));
    },
    true
  );
})();
